export function ChevronIcon({
  position,
  enableTransition = false,
  ...svgProps
}: React.SVGProps<SVGSVGElement> & {
  position: 'up' | 'down' | 'left' | 'right';
  enableTransition?: boolean;
}) {
  let rotate = '';
  switch (position) {
    case 'up':
      rotate = 'rotate(180deg)';
      break;
    case 'left':
      rotate = 'rotate(90deg)';
      break;
    case 'right':
      rotate = 'rotate(-90deg)';
      break;
    default:
      rotate = 'rotate(0deg)';
      break;
  }
  const { style, ...restProps } = svgProps;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{
        transform: rotate,
        transition: enableTransition ? 'transform 200ms' : undefined,
        ...style,
      }}
      {...restProps}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
